import { getWidget } from '../shared/utils';
import { setHiddenFields } from '../protocol/utils/utils';
import { 
  protocolClassNames,
  objectClassNames,
 } from '../classes';

const hideFields = {
  root: [
    "more_info",
    "trial_info",
    "participant_flow",
    "baseline_characteristics",
    "outcome_measures",
    "adverse_events",
  ]
}

export const jrctResultsUISchema = (configs) => {
  const preview = configs?.preview;
  const formData = configs?.formData;
  const disableValidation = configs?.disableValidation || false

  let returnObj = {
    "ui:options": {
      classNames: protocolClassNames
    },
    results: {
      "ui:order": ["trial_info", "participant_flow", "baseline_characteristics", "outcome_measures", "adverse_events", "*"],
      "ui:options": {
        classNames: {
          objectInnerContainer: "section-container",
        }
      },
      research_information: {
        "ui:options": {
          title: "Research Information",
          translations: {
            jp: {
              title: "研究の情報"
            }
          },
          classNames: objectClassNames.primary
        },
        "ui:order": [
          "*",
        ],
        study_information: {
          "ui:options": {
            title: "Study Information",
            translations: {
              jp: {
                title: "研究情報"
              }
            },
            classNames: {
              objectTitle: "rjs-h2",
            }
          },
          category_of_study: {
            "ui:options": {
              label: false,
              title: "Category of study",
              disableValidation,
              disabled: true,
              required: true,
              translations: {
                jp: {
                  title: "研究の種類"
                }
              },
              required: true,
              classNames: {
                fieldContainer: "rjs-col-xl"
              }
            }
          },
          date_of_registration: {
            "ui:options": {
              label: false,
              title: "Date of Registration",
              required: true,
              disableValidation,
              translations: {
                jp: {
                  title: "登録年月日",
                }
              },
              classNames: {
                field: "rjs-col-date"
              }
            },
            "ui:widget": getWidget({ type: "date", preview })
          },
          jrct_number: {
            "ui:options": {
              title: "jRCT number",
              label: false,
              required: true,
              disabled: true,
              disableValidation,
              translations: {
                jp: {
                  title: "jRCT番号",
                }
              },
              classNames: {
                fieldContainer: "rjs-col-xl",
              },
            }
          },
          official_title: {
            "ui:options": {
              label: false,
              title: "Scientific Title",
              required: true,
              disableValidation,
              disabled: true,
              charCountEnabled: true,
              maxChars: 2000,
              translations: {
                jp: {
                  title: "試験の名称"
                }
              },
              classNames: {
                fieldContainer: "rjs-full",
              },
            },
            "ui:widget": getWidget({ type: "textarea", preview })
          },
          brief_title: {
            "ui:options": {
              label: false,
              title: "Public Title",
              required: true,
              disableValidation,
              disabled: true,
              charCountEnabled: true,
              maxChars: 2000,
              translations: {
                jp: {
                  title: "平易な試験等の名称"
                }
              },
              classNames: {
                fieldContainer: "rjs-full",
              },
            },
            "ui:widget": getWidget({ type: "textarea", preview })
          },
          irbs: {
            "ui:options": {
              title: "IRB Name",
              label: false,
              required: true,
              disableValidation,
              disabled: true,
              classNames: {
                fieldContainer: "rjs-col-1-2"
              },
              translations: {
                jp: {
                  title: "IRBの名称"
                }
              }
            },
            "ui:widget": getWidget({ type: "SelectTag", preview })
          }
        },
        summary_of_results: {
          "ui:options": {
            title: "Summary of Results",
            translations: {
              jp: {
                title: "観察研究結果の要約"
              }
            },
            classNames: {
              objectTitle: "rjs-h2",
            }
          },
          milestone_dates: {
            "ui:options": {
              // title: "Milestone Dates",
              classNames: {
                fieldContainer: "rjs-full",
                objectTitle: "rjs-h2"
              }
            },
            lpo: {
              "ui:options": {
                title: "Study Completion Date",
                classNames: {
                  objectTitle: "rjs-h3",
                  fieldContainer: "rjs-col-1-2"
                },
                translations: {
                  jp: {
                    title: "実施期間（終了日）"
                  }
                }
              },
              baseline: {
                "ui:options": {
                  title: "Baseline",
                  label: false,
                  hide: true,
                  disabled: true,
                  classNames: {
                    fieldContainer: "rjs-col-1-3"
                  }
                },
                "ui:widget": getWidget({ type: "date", preview })
              },
              forecast: {
                "ui:options": {
                  title: "Forecast",
                  hide: true,
                  label: false,
                  disabled: true,
                  classNames: {
                    fieldContainer: "rjs-col-1-3"
                  }
                },
                "ui:widget": getWidget({ type: "date", preview })
              },
              actual: {
                "ui:options": {
                  title: "Actual",
                  label: false,
                  disabled: true,
                  required: true,
                  classNames: {
                    fieldContainer: "rjs-col-1-3"
                  },
                  translations: {
                    jp: {
                      title: "現在の"
                    }
                  }
                },
                "ui:widget": getWidget({ type: "date", preview })
              },
            },
          },
          enrollment_number: {
            "ui:options": {
              title: "Number of Subjects",
              required: true,
              label: false,
              disableValidation,
              disabled: true,
              charCountEnabled: true,
              maxChars: 6,
              translations: {
                jp: {
                  title: "実施症例数"
                }
              },
              classNames: {
                fieldContainer: "rjs-col-lg",
                field: "rjs-col-sm"
              },
            },
          },
          baseline_characteristics: {
            "ui:options": {
              label: false,
              title: "Baseline Characteristics",
              required: true,
              disableValidation,
              charCountEnabled: true,
              maxChars: 6000,
              translations: {
                jp: {
                  title: "試験等の対象者の背景情報"
                }
              },
              classNames: {
                fieldContainer: "rjs-full",
              },
            },
            "ui:widget": getWidget({ type: "textarea", preview })
          },
          participant_flow: {
            "ui:options": {
              label: false,
              title: "Participant Flow",
              disableValidation,
              required: true,
              charCountEnabled: true,
              maxChars: 8000,
              translations: {
                jp: {
                  title: "試験等のデザインに応じた進行状況に関する情報"
                }
              },
              classNames: {
                fieldContainer: "rjs-full",
              },
            },
            "ui:widget": getWidget({ type: "textarea", preview })
          },
          adverse_events: {
            "ui:options": {
              label: false,
              title: "Adverse Events",
              required: true,
              disableValidation,
              charCountEnabled: true,
              maxChars: 8000,
              translations: {
                jp: {
                  title: "有害事象の発生状況のまとめ"
                }
              },
              classNames: {
                fieldContainer: "rjs-full",
              },
            },
            "ui:widget": getWidget({ type: "textarea", preview })
          },
          outcome_measures: {
            "ui:options": {
              label: false,
              title: "Outcome Measures",
              required: true,
              disableValidation,
              charCountEnabled: true,
              maxChars: 8000,
              translations: {
                jp: {
                  title: "主要評価項目及び副次評価項目のデータ解析及び結果"
                }
              },
              classNames: {
                fieldContainer: "rjs-full",
              },
            },
            "ui:widget": getWidget({ type: "textarea", preview })
          },
          brief_summary: {
            "ui:options": {
              title: "Brief Summary",
              charCountEnabled: true,
              maxChars: 512,
              label: false,
              required: true,
              disableValidation,
              translations: {
                jp: {
                  title: "簡潔な要約"
                }
              },
              classNames: {
                fieldContainer: "rjs-full"
              }
            },
            "ui:widget": getWidget({ type: "textarea", preview })
          },
          anticipated_date_of_disclosure: {
            "ui:options": {
              label: false,
              title: "Anticipated Date of Disclosure",
              required: true,
              translations: {
                jp: {
                  title: "公開予定日"
                }
              },
              classNames: {
                field: "rjs-col-date"
              }
            },
            "ui:widget": getWidget({ type: "date", preview })
          },
          first_journal_publication_date: {
            "ui:options": {
              label: false,
              title: "Date of the first journal publication of results",
              translations: {
                jp: {
                  title: "結果に関する最初の出版物での発表日"
                }
              },
              classNames: {
                field: "rjs-col-date"
              }
            },
            "ui:widget": getWidget({ type: "date", preview })
          },
          urls_related_to_result: {
            "ui:options": {
              title: "URL hyperlink(s) related to results and publications",
              label: false,
              translations: {
                jp: {
                  title: "結果と出版物に関するURL"
                }
              },
              classNames: {
                fieldContainer: "rjs-full"
              }
            },
            "ui:widget": getWidget({ type: "textarea", preview })
          }
        },
        ipd_sharing: {
          "ui:options": {
            title: "IPD Sharing",
            translations: {
              jp: {
                title: "シェアリング（匿名化された臨床研究の対象者単位のデータの共有）"
              }
            },
            classNames: {
              objectTitle: "rjs-h2",
              fieldContainer: "rjs-full"
            }
          },
          plan_to_share_IPD: {
            "ui:options": {
              title: "Plan to Share IPD",
              label: false,
              disabled: true,
              translations: {
                jp: {
                  title: "IPDデータを共有する計画"
                }
              },
              classNames: {
                fieldContainer: "rjs-col-1-2"
              }
            },
            "ui:widget": getWidget({ type: "radio", preview })
          },
          plan_description: {
            "ui:options": {
              title: "Plan Description",
              errorMessage: "IPD Description must have no more than 1000 characters",
              label: false,
              disabled: true,
              translations: {
                jp: {
                  title: "計画の説明"
                }
              },
              classNames: {
                fieldContainer: "rjs-full"
              }
            },
            "ui:widget": getWidget({ type: "textarea", preview })
          }
        }
      },
      ...setHiddenFields(hideFields.root)
    }
  }

  return returnObj;
}